import React from 'react'
import classNames from 'classnames'
import { useCcqRun, useCcqRunDisplay } from './useCcqRun'
import { CcqStatusArc } from './CcqStatusArc'
import { CcqArcModes } from './ccqStatusArcModes'
import { ccqOutOf, ccqSourceNames, ccqStatusChecking, ccqStatusDone, ccqStatusStopped } from './ccqRunCopy'
import styles from './CcqStatusLine.module.scss'
import { CCQ_BADGE_CLASS } from './ccqClassNames'

// Only the phase sentence is live: the counter changes many times a second and would flood a screen reader.

interface CcqStatusLineProps {
  isCollapsed: boolean
}

export const CcqStatusLine: React.FC<CcqStatusLineProps> = ({ isCollapsed }) => {
  const { hasCounts, isDone, total, stoppedAfter, execution } = useCcqRun()
  const display = useCcqRunDisplay()

  const sentence =
    stoppedAfter !== null ? ccqStatusStopped(stoppedAfter, total) : isDone ? ccqStatusDone(total) : ccqStatusChecking(ccqSourceNames(execution.sources))

  const arcMode = stoppedAfter !== null ? CcqArcModes.PROGRESS : isDone ? CcqArcModes.DONE : hasCounts ? CcqArcModes.PROGRESS : CcqArcModes.SPINNER
  const arcChecked = stoppedAfter ?? display.checked

  return (
    <div className={classNames(styles.collapser, { [styles.collapsed]: isCollapsed })} aria-hidden={isCollapsed}>
      <div className={styles.inner}>
        <div className={styles.spacer}>
          <div
            className={classNames(
              styles.line,
              'd-flex align-items-center gap-2 p-3 border rounded-4 zocks-bg-color-white',
              isDone ? 'zocks-border-color-gray-200' : styles.active,
            )}
          >
            <span className='d-inline-flex flex-shrink-0 me-1'>
              <CcqStatusArc mode={arcMode} fraction={total > 0 ? arcChecked / total : 0} isCounting={display.isAnimating} />
            </span>
            <span className='paragraph-medium bold zocks-text-gray-900' role='status' aria-live='polite'>
              {sentence}
            </span>
            {hasCounts && !isDone ? (
              <span className={classNames(styles.counterIn, styles.counter, CCQ_BADGE_CLASS, 'ms-auto flex-shrink-0 text-nowrap zocks-text-gray-900')}>
                {ccqOutOf(display.checked, total)}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
